require('dotenv').config()
const _sortBy = require('lodash/sortBy')
const contentful = require('contentful')

const types = [
  'space',
  'locations',
  'flora',
  'fauna',
  'tracks',
  'pages',
  'infoPages',
  'glossary',
  'alerts'
]

function fetchContentfulData ({
  key,
  spaceID = process.env.CONTENTFUL_ID,
  accessToken = process.env.CONTENTFUL_TOKEN,
  preview = false
}) {
  const client = contentful.createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: spaceID,
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken,
    host: preview ? 'preview.contentful.com' : null
  })

  let query = key
  return new Promise((resolve, reject) => {
    if (preview) console.log(`Fetching ${query}${preview ? ' – preview' : ''}`)

    if (query === 'space') {
      // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
      return client
        .getSpace()
        .then(space => resolve(space))
        .catch(error => reject(error))
    }

    if (query === 'locations') query = 'location'
    if (query === 'tracks') query = 'track'
    if (query === 'pages') query = 'page'
    if (query === 'infoPages') query = 'infoPage'
    if (query === 'glossary') query = 'glossary'

    return client
      .getEntries({
        content_type: query
      })
      .then(response => resolve(response.items))
      .catch(error => reject(error))
  })
}

function updateData ({ key, value, dataObj }) {
  dataObj[key] = sortByOrder(value)
}

function sortByOrder (obj) {
  if (obj.sys && obj.sys.type === 'Space') return obj
  const byOrder = item => item.fields.order
  return _sortBy(obj, byOrder)
}

function fetchAllContentTypes (spaceID, accessToken, preview = false) {
  const promises = types.map(type => {
    return new Promise((resolve, reject) => {
      fetchContentfulData({ key: type, accessToken, spaceID, preview })
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  })

  let dataObj = {}

  return Promise.all(promises)
    .then(data => {
      data.forEach((itemData, i) => {
        updateData({ key: types[i], value: itemData, dataObj })
      })
      return dataObj
    })
    .catch(error => console.log(error))
}

module.exports = { fetchContentfulData, fetchAllContentTypes }



// WEBPACK FOOTER //
// ./src/utils/fetch.js